var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogosLinkedinIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_2754)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5614 25.5618H21.1164V18.6005C21.1164 16.9406 21.0867 14.8037 18.8045 14.8037C16.4893 14.8037 16.1351 16.6123 16.1351 18.4797V25.5614H11.6902V11.2462H15.9573V13.2025H16.0171C16.4441 12.4723 17.0612 11.8716 17.8026 11.4644C18.5441 11.0572 19.3821 10.8587 20.2274 10.8901C24.7327 10.8901 25.5633 13.8535 25.5633 17.7087L25.5614 25.5618ZM6.67453 9.28953C5.24988 9.28976 4.09477 8.135 4.09453 6.71035C4.0943 5.2857 5.24895 4.13058 6.67359 4.13035C8.09824 4.13 9.25336 5.28476 9.25359 6.70941C9.25372 7.39356 8.98207 8.04973 8.4984 8.53359C8.01474 9.01746 7.35868 9.28937 6.67453 9.28953ZM8.89711 25.5619H4.44738V11.2462H8.89699V25.5618L8.89711 25.5619ZM27.7774 0.00218342H2.21379C1.00559 -0.0114103 0.0147656 0.956441 0 2.16464V27.8349C0.0142969 29.0437 1.005 30.0125 2.21367 29.9998H27.7774C28.9887 30.0148 29.9832 29.0461 30 27.8349V2.16265C29.9828 0.952105 28.9881 -0.0156291 27.7774 0.000191237",
    fill: "#0A66C2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_2754"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosLinkedinIcon);
export default __webpack_public_path__ + "static/media/logos_linkedin-icon.7dd21a16b3955fd4d11f2b9e8fcc7755.svg";
export { ForwardRef as ReactComponent };